module.exports = __webpack_public_path__ + "static/media/logo_line.e79c1e65.svg";